import { GetAuthApi, Post } from "../services/services";
import { AuthenticationService } from "../services/auth.service";

// export const login = (post,cb)=> dispatch =>{
//     Post("/user/login",post,(st,res)=>{
//         if(st){
//             if(res.status === "Success"){
//                 dispatch({
//                     type:"LOGIN",
//                     payload:res,
//                 });
//                 localStorage.setItem('token',res.token);
//                     cb(true);
//             }else{
//                 cb(false)
//             }
//         }else{
//             cb(false)
//         }
//     })
// }

export const getMyProfile = () => async (dispatch) => {
  try {
    const response = await AuthenticationService.myProfile();

    dispatch({
      type: "GET_MY_PROFILE",
      payload: {
        ...response.data,
        permissions: response.data.permissions,
      },
    });

    return response;
  } catch {
    dispatch({ type: "CLEAR_STORE" });
    return null;
  }
};

// export const Update_user =(post) => dispatch =>{
//     dispatch({
//         type:'LOGIN',
//         payload:post
//     });
// }

export const Get_Users = (post, cb) => (dispatch) => {
  Post("/admin/users", post, (st, res) => {
    console.log("RES USER: ", res);
    if (st) {
      dispatch({
        type: "GET_USERS",
        payload: res,
      });
    }
    // cb();
  });
};

export const Get_Roles = (cb) => (dispatch) => {
  GetAuthApi("/admin/roles", (st, res) => {
    if (st) {
      dispatch({
        type: "GET_ROLES",
        payload: res.data ? res.data : [],
      });
      cb(res);
    }
  });
};

export const App_Config = () => (dispatch) => {
  Post("/general/appConfig", {}, (status, response) => {
    if (response && status && response.mainCategory) {
      dispatch({
        type: "GET_APP_CONFIG",
        payload: response,
      });
    }
  });
};
export const Get_Settings = () => (dispatch) => {
  Post("/settings/getSettings", {}, (status, response) => {
    if (response && status && response.companyConfig) {
      dispatch({
        type: "GET_SETTINGS",
        payload: response,
      });
    }
  });
};

export const Get_Carousel = () => (dispatch) => {
  Post("/carousel/getAllCarousel", {}, (status, response) => {
    if (response && status && response.status === "Success" && response.data) {
      dispatch({
        type: "GET_CAROUSEL",
        payload: response.data,
      });
    }
  });
};
